export default "__VITE_ASSET__YiKk1l2r__"